<template>
  <section
    :class="getRowBackgroundClass() + ' pb-4'"
    v-if="
      !tripfinderResult &&
      tripfinderViewModel &&
      !tripfinderViewModel.filter.preFilters.length &&
      tripfinderViewModel.filter.filters.length
    "
  >
    <facet-search-bar />
  </section>
  <section
    :class="
      getRowBackgroundClass() +
      ' tripfinder position-relative overflow-hidden pt-2 pb-4'
    "
    v-if="
      !hasTags &&
      !tripfinderResult &&
      tripfinderViewModel &&
      tripfinderViewModel.filter.preFilters.length
    "
  >
    <pre-filter-search :preFilters="tripfinderViewModel.filter.preFilters" />
  </section>

  <section
    id="tripfinderResults"
    :class="getRowBackgroundClass() + ' pb-6'"
    v-if="tripfinderResult"
  >
    <tripfinder-results />
  </section>
</template>

<script>
import FacetSearchBar from "./components/FacetSearchBar.vue";
import PreFilterSearch from "./components/PreFilterSearch.vue";
import TripfinderResults from "./components/TripfinderResults.vue";
import PageTravelCard from "./components/PageTravelCard.vue";
import PageHotelCard from "./components/PageHotelCard.vue";
import PageExperienceCard from "./components/PageExperienceCard.vue";
import FacetDropdownListItem from "./components/FacetDropdownListItem.vue";
export default {
  name: "TripfinderApp",
  components: {
    FacetSearchBar,
    PreFilterSearch,
    TripfinderResults,
    PageTravelCard,
    PageHotelCard,
    PageExperienceCard,
    FacetDropdownListItem,
  },
  computed: {
    tripfinderViewModel() {
      return this.$store.state.tripfinderViewModel;
    },
    tripfinderSelectedFilters() {
      return this.$store.state.tripfinderSelectedFilters;
    },
    tripfinderResult() {
      return this.$store.state.tripfinderResult;
    },
  },
  data() {
    return {
      hasTags: true,
    };
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      // Getting filters
      this.$store
        .dispatch("getTripfinderFilter", this.$store.getters.pageId)
        .then(() => {
          let tagIds = [];
          this.$store.dispatch("getUrlFacets").then((facets) => {
            tagIds = facets.getAll("facet");
            if (tagIds.length) {
              let tagIdsCount = 0;
              tagIds.forEach((id) => {
                this.$store.dispatch("selectItem", id);
                tagIdsCount++;
                if (tagIdsCount === tagIds.length) {
                  this.$store.dispatch("searchTripfinderList");
                }
              });
            } else {
              this.hasTags = false;
              if (
                this.$store.state.tripfinderViewModel.filter.preFilters.length
              ) {
                const tripfinderHero =
                  document.getElementById("tripfinderHero");
                if (tripfinderHero) tripfinderHero.classList.remove("d-none");
              }
            }
          });
        });
    },
    getUrlFacets: function () {
      return new URLSearchParams(decodeURI(window.location.hash.split("?")[1]));
    },
    getFacetsFromSelectedFilters: function () {
      let params = new URLSearchParams();
      this.tripfinderSelectedFilters.forEach((filter) =>
        params.append("facet", filter.id)
      );
      return decodeURI(params) ? "#?" + decodeURI(params) : "#";
    },
    getRowBackgroundClass() {
      return "bg__" + this.tripfinderViewModel.backgroundColorBottom;
    },
    preventFocus: function (event) {
      // Prevents focus styling on click
      event.preventDefault();
    },
  },
};
</script>
